import * as types from './types';

function setNewRouteLinks(data, newRoutesId) {
    return {
        meta: newRoutesId,
        payload: data,
        type: types.SET_NEW_ROUTE_LINKS,
    };
}

export {
    setNewRouteLinks,
};

export default {
    setNewRouteLinks,
};
